import { combineReducers } from "redux";

import business from "../reducers/business";
import userData from "../reducers/user";
import feedback from "../reducers/feedback";

export default combineReducers({
    business,
    userData,
    feedback
})